export const releaseOptions = [
    "LP",
    "EP",
    "Demo",
    "Mixtape",
    "Single",
    "Instrumental"
]
  